import React from "react";
import "./ShipmentUpdate.scss";
import "../ShipmentManagement/ShipmentManagement.scss";
import "../ShipmentManagement/ShipmentManagementHeader/ShipmentManagementHeader.scss";
import { Tab, Nav } from "react-bootstrap";
import { Button } from "antd";
import { ReactSVG } from "react-svg";
import ShipmentUpdateElements from "./ShipmentUpdateElements/ShipmentUpdateElements";
import ShipmentUpdateEmpty from "./ShipmentUpdateEmpty/ShipmentUpdateEmpty";
import { getIcon } from "../../utils/images";
import { useNavigate } from "react-router-dom";

const ShipmentUpdate = ({ updates, refetch }) => {

  const attentionUpdates = updates?.filter((u) => u.attention) || [];
  const navigate = useNavigate();

  function redirectToNotifications() {
    navigate("/notifications")
  }

  return (
    <div className="ShipmentUpdate">
      <div className="header">
        <div className="title">
          Updates
        </div>
        <div>
          <Button className="link-btn see-all-btn" onClick={redirectToNotifications}>See All</Button>
        </div>
      </div>

      <Tab.Container defaultActiveKey="attention">
        <Nav className="app-tabs update-bar">
          <Nav.Item>
            <Nav.Link eventKey="attention">
              <ReactSVG src={getIcon('attention')} />
              <div>Attention <span className="attention">({attentionUpdates.length})</span></div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="all">
              <div>All ({updates.length})</div>
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="attention">
            {
              attentionUpdates.length
                ? <ShipmentUpdateElements updates={attentionUpdates} refetch={refetch} />
                : <ShipmentUpdateEmpty isAttention={true} />
            }
          </Tab.Pane>
          <Tab.Pane eventKey="all">
            {
              updates.length
                ? <ShipmentUpdateElements updates={updates} refetch={refetch} />
                : <ShipmentUpdateEmpty />
            }
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  )
};

export default ShipmentUpdate;
